export function protoExtend<T extends object, U extends object>(
  obj: T,
  extension: U
): T & U {
  function O(this: T & U, extension: U) {
    Object.assign(this, extension);
  }

  O.prototype = obj;
  // @ts-ignore : constructeur non standard, c'est voulu
  return new (O as any)(extension) as T & U;
}